/**
 * Модальное окно подтверждения действия в виде окна макета (workspace-dialog: шапка с заголовком,
 * пояснение notice-note и form-footer с «Отмена» и подтверждением — так макет подтверждает
 * команды получателя, integration-forms.js). Заменяет window.confirm во всех местах проекта.
 * Построено на общем Dialog: рисуется в body, поверх открытого окна позиционируется от экрана,
 * Escape и щелчок по подложке отменяют только подтверждение; для вспомогательных технологий —
 * модальный диалог, названный заголовком и описанный текстом под ним.
 */

import { useTranslation } from 'react-i18next';
import { Button } from '@/components/Button';
import { Dialog } from '@/components/Dialog';

interface ConfirmModalProps {
	/** Управление видимостью */
	open: boolean;
	/** Заголовок окна */
	title: string;
	/** Описание действия */
	description: string;
	/** Текст кнопки подтверждения; по умолчанию — «Подтвердить» из словаря */
	confirmLabel?: string;
	/** Текст кнопки отмены; по умолчанию — «Отмена» из словаря */
	cancelLabel?: string;
	/** Деструктивное действие — кнопка подтверждения красная */
	danger?: boolean;
	/** Колбэк подтверждения */
	onConfirm: () => void;
	/** Колбэк отмены */
	onCancel: () => void;
}

export function ConfirmModal({
	open,
	title,
	description,
	confirmLabel,
	cancelLabel,
	danger = false,
	onConfirm,
	onCancel,
}: ConfirmModalProps) {
	const { t } = useTranslation('common');

	return (
		<Dialog
			open={open}
			onOpenChange={(next) => !next && onCancel()}
			title={title}
			description={description}
		>
			<div className="ws-form-footer">
				<Button variant="secondary" onClick={onCancel}>
					{cancelLabel ?? t('actions.cancel')}
				</Button>
				<Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>
					{confirmLabel ?? t('actions.confirm')}
				</Button>
			</div>
		</Dialog>
	);
}
